import "./lib/polyfills";
import "./lib/error-logger";
import {createRoot} from "react-dom/client";
import App from "virtual:mode-app";

const mode = process.env.REACT_APP_MODE;

// Register service worker (only for main app, not steamy or open modes)
if ("serviceWorker" in navigator && mode !== "steamy" && mode !== "open") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn(err);
    });
  });
}

const onLoaded = new Promise((res) => window.document.addEventListener("DOMContentLoaded", res));

void onLoaded.then(() => {
  const appEl = window.document.getElementById("app");

  const root = createRoot(appEl);
  root.render(<App tab="home" />);
  const loaderEl = window.document.getElementById("preload");
  if (loaderEl && loaderEl.parentNode) {
    loaderEl.parentNode.removeChild(loaderEl);
  }
});
